import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

function loadView(view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `${view}.vue`)
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    /* Routes for public user */
    { name: 'home', path: '/', component: require('./public/home/home.vue').default, meta: { requiresAuth: false } },
    { name: 'complaints', path: '/complaints', component: require('./public/complaints/complaints.vue').default, meta: { requiresAuth: false } },
    { name: '404', path: '*', component: require('./public/404/404.vue').default, meta: { requiresAuth: false } },

    /* Routes for public forms */
    { name: 'customerEvaluation', path: '/customerEvaluation', component: loadView('./forms/customerEvaluation/customerEvaluation'), meta: { requiresAuth: false } },
    { name: 'customerEvaluation', path: '/customerEvaluation/:id/', component: loadView('./forms/customerEvaluation/customerEvaluation'), meta: { requiresAuth: false } },

    /* Routes for customer & employee */
    { name: 'login', path: '/login', component: require('./common/account/login.vue').default, meta: { requiresAuth: false } },
    { name: 'newCustomer', path: '/newCustomer', component: require('./common/account/newCustomer.vue').default, meta: { requiresAuth: false } },
    { name: 'confirmLink', path: '/activate/:code', component: require('./common/account/confirmLink.vue').default, meta: { requiresAuth: false } },
    { name: 'changePassword', path: '/account/changePassword', component: require('./common/account/changePassword.vue').default, meta: { requiresAuth: true } },
    { name: 'resetPassword', path: '/account/resetPassword/:email_phone', component: require('./common/account/resetPassword.vue').default, meta: { requiresAuth: false } },
    { name: 'ebill', path: '/ebill', component: require('./common/account/ebillRegistration.vue').default, meta: { requiresAuth: false } },
    { name: 'unsubscribe', path: '/unsubscribe', component: require('./common/account/unsubscribe.vue').default, meta: { requiresAuth: false } },
    { name: 'requestChangeEmail', path: '/account/requestChangeEmail', component: require('./common/account/requestChangeEmail.vue').default, meta: { requiresAuth: true } },
    { name: 'requestChangeMobile', path: '/account/requestChangeMobile', component: require('./common/account/requestChangeMobile.vue').default, meta: { requiresAuth: true } },
    { name: 'changeEmail', path: '/changeEmail/:code', component: require('./common/account/changeEmail.vue').default, meta: { requiresAuth: false } },
    { name: 'changeEmailComplete', path: '/changeEmailComplete/:code', component: require('./common/account/changeEmailComplete.vue').default, meta: { requiresAuth: false } },

    /* Routes for customer */
    { name: 'account', path: '/account', component: loadView('./user/customer/details'), meta: { requiresAuth: true } },
    { name: 'financial', path: '/financial', component: loadView('./user/customer/finDetails'), meta: { requiresAuth: true } },
    { name: 'apps', path: '/apps', component: loadView('./user/applications/applications'), meta: { requiresAuth: true } },
    { name: 'app', path: '/app/:type/:id', component: loadView('./user/applications/application'), meta: { requiresAuth: true } },
    { name: 'emails', path: '/emails', component: loadView('./user/emails/emails'), meta: { requiresAuth: true } },
    { name: 'attachments', path: '/attachments', component: loadView('./user/attachments/attachments'), meta: { requiresAuth: true } },
    { name: 'dashscreen', path: '/dashscreen', component: loadView('./user/dashscreen/dashscreen'), meta: { requiresAuth: true } },
    { name: 'email', path: '/email/:id', component: loadView('./user/emails/email'), meta: { requiresAuth: true } },
    { name: 'readings', path: '/app/readings', component: loadView('./user/customer/readings'), meta: { requiresAuth: true } },
    { name: 'userHome', path: '/userHome', component: loadView('./user/home'), meta: { requiresAuth: true } },
    { name: 'billPayment', path: '/billPayment', component: loadView('./user/customer/payBill'), meta: { requiresAuth: true } },


    { name: 'contactUs', path: '/contactUs', component: loadView('./common/contactUs/contactUs'), meta: { requiresAuth: true } },

    ],
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});
